import React from "react";
import BackgroundTexture from "../../Elements/Textures/BackgroundTexture";
import MainReelSet from "./MainReelSet/MainReelSet";
import Logo from "../../Components/UI/Logo/Logo";

const MainGame = ({ dimensions, symbolSize, reelRefs }) => {
  return (
    <>
      <Logo dimensions={dimensions} symbolSize={symbolSize} zIndex={5} />
      <BackgroundTexture dimensions={dimensions} type={"main"} />
      <MainReelSet
        dimensions={dimensions}
        symbolSize={symbolSize}
        reelRefs={reelRefs}
      />
    </>
  );
};

export default MainGame;
